import styled from 'styled-components';

export const Container = styled.div`
  width: 100vw;
  height: 100vh;
  display: flex;
  justify-content: center;
  background-color: #262626;
  padding-top: 40px;
`;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
`;

export const Card = styled.div`
  display: flex;
  flex-direction: column;
  width: 450px;
  border-radius: 5px;
  background-color: ${(props) => props.theme.colors.card};
  padding: 40px 30px;
  box-shadow: 0 2px 2.62px rgba(0, 0, 0, 0.23);
  gap: 15px;
`;

export const Separator = styled.div`
  display: flex;
  align-items: center;
  gap: 20px;
  margin: 10px 0;
`;

export const Line = styled.div`
  flex: 1;
  height: 1px;
  background-color: rgba(128, 128, 128, 0.3);
`;

export const SeparatorText = styled.span`
  color: ${(props) => props.theme.colors.text};
`;

export const Register = styled.button`
  text-align: center;
  width: 450px;
  padding: 15px;
  border-radius: 6px;
  background-color: ${(props) => props.theme.colors.card};
  color: ${(props) => props.theme.colors.text};
  border: none;
  cursor: pointer;
`;

export const LinkText = styled.span`
  color: ${(props) => props.theme.colors.info};
  font-weight: bold;
`;

export const ForgotPasswordLink = styled.span`
  color: ${(props) => props.theme.colors.text};
  cursor: pointer;
`;
